import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { createStructuredSelector } from 'reselect';
import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex,
    WorksheetEntitySummarySumTotal
} from 'services/worksheet/types';
import { makeSelectHectares } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

interface ConnectedProps {
    hectares: WorksheetEntitySummarySumTotal;
}

type Props = OwnProps & ConnectedProps;

export class HectaresTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { hectares } = this.props;

        return <TableCell>{hectares}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    hectares: makeSelectHectares()
});

export default connect(mapStateToProps)(HectaresTableCellComponent);
